<span class="card-image">
	@if (item().imageUrl) {
		<img [src]="item().imageUrl" [alt]="item().data.sport" />
	}
</span>

<span class="card-text">
	<span class="card-name truncate-text">{{ item().label }}</span>

	<span class="card-meta">
		@if (item().isLive) {
			<live-event-badge class="live-badge" />
		}
		@if (timeLabel()) {
			<span class="start">{{ timeLabel() }}</span>
			<span class="separator">-</span>
		}
		<span class="league truncate-text">{{ item().league }}</span>
	</span>
</span>
